import { serviceRequest } from 'utils/http';
import { Service } from 'common/api';

export function setSiteEmployeeProductUpdatesReadAPI(siteEmployeeId: string) {
  return serviceRequest(() => Service.productUpdateControllerSetRead(siteEmployeeId));
}
